module.exports = __webpack_public_path__ + "img/MoonSword 5.96b6a47c.png";